export const GET_ALL_CONTACT_LINK = "GET_ALL_CONTACT_LINK";
export const GET_ALL_CONTACT_LINK_SUCCESS = "GET_ALL_CONTACT_LINK_SUCCESS";
export const GET_ALL_CONTACT_LINK_FAIL = "GET_ALL_CONTACT_LINK_FAIL";

export const GET_ALL_SUPPORT_LINK = "GET_ALL_SUPPORT_LINK";
export const GET_ALL_SUPPORT_LINK_SUCCESS = "GET_ALL_SUPPORT_LINK_SUCCESS";
export const GET_ALL_SUPPORT_LINK_FAIL = "GET_ALL_SUPPORT_LINK_FAIL";
